export default function (method, data) {
  switch(method) {
    case 'openurl': {
      if (/http[s]*/.test(data.url)) {
        location.href = data.url
      } else {
        alert('url不合法')
      }
    } break

    case 'getversion': {
      return Promise.resolve({ code: 200, data: { version: '100.1.0'}})
    }

    case 'getlocation': {
      return Promise.resolve({
        code: 200,
        data: {
          AOIName: '',
          POIName: '西溪壹号',
          // adcode: 330106,
          adcode: '',
          city: '杭州',
          citycode: '0571',
          country: '中国',
          district: '西湖区',
          errorCode: 0,
          lat: 30.281809,
          lng: 120.068968,
          location: 0,
          province: '浙江省',
          street: '花匠路',
          streetNum: '796号'
        }
      })
    }
  }
}
